import { PlusCircleMultipleOutlineIcon } from './PlusCircleMultipleOutlineIcon';

/**
 * author: Google
 * id 0C5565E9-9E74-4E50-BF9E-6F904BB83E52
 * name plus-circle-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-circle-multiple-outline.svg
 * tags
 */
export const PlusCirclesOutlineIcon = PlusCircleMultipleOutlineIcon;
export default PlusCirclesOutlineIcon